<template>
  <div>
    <!-- 角色管理标题 -->
    <ots-main-title></ots-main-title>
    <div class="titleTips">
      <span class="titleTips-left">
        {{ roleType == 1 ? "院校管理员" : ( roleType == 2 ?"教学点管理员" :'巡考教师') }}
      </span>
      <span class="titleTips-right">
        {{ roleType == 1 ? "院校权限" :(roleType == 2 ?"教学点权限":'巡考员权限')}}
      </span>
    </div>
    <div class="roleTypeBorder">
      <div class="title">权限选择</div>
      <div class="roleTypeMenu">
        <el-form>
          <el-tree
            :disabled="true"
            :data="roleTypeMenu"
            show-checkbox
            node-key="id"
            default-expand-all
            :default-checked-keys="roleTypeId"
            :props="defaultProps"
            @check="currentChecked"
            ref="tree"
          >
          </el-tree>
        </el-form>
      </div>
    </div>
  </div>
</template>
 
<script>
import { mapMutations } from "vuex";
import { getRoleTypeMenuInfo, addRoleMenuSet } from "@/http/modules/user.js";
export default {
  name: "getRoleType",
  data() {
    return {
      saveMethods: "submitForm",
      backMethods: "goIndex",
      cancelName: "取消",
      okName: "确认",
      roleType: this.$route.query.roleType,
      roleTypeMenu: [],
      roleTypeId: [],
      roleTypeIdP: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  mounted() {
    this.getRoleTypeMenu();
    this.SAVE_PAGE_THIS(this);
  },
  methods: {
    ...mapMutations(["SAVE_PAGE_THIS"]),
    /**********************************
     * @this 角色授权(确认)
     **********************************/
    submitForm() {
      this.roleTypeId = this.roleTypeId.concat(this.roleTypeIdP);
      this.roleTypeId = [...new Set(this.roleTypeId)]
      let param = {
        roleId: this.$route.query.roleId,
        menuIds: this.roleTypeId.join(),
      };
      addRoleMenuSet(param).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.getRoleTypeMenu();
        }
      });
    },

    /**********************************
     * @this 取消
     **********************************/
    goIndex() {
      this.$router.push({
        name: "rolemanagement",
      });
    },

    /**********************************
     * @this 获取所有选中的表单
     **********************************/
    currentChecked(nodeObj, SelectObj) {
      this.roleTypeId = SelectObj.checkedKeys;
      this.roleTypeIdP = SelectObj.halfCheckedKeys;
    },

    /**********************************
     * @this 获取权限选项列表
     **********************************/
    getRoleTypeMenu() {
      let roleId='';
      if(this.$route.query.roleType === 3){
        roleId = 6
      }else{
        roleId =  Number(this.$route.query.roleType) + 1
      }
      this.roleTypeMenu = [];
      this.roleTypeId = [];
      let param = {
        roleId: this.$route.query.roleId,
        typeId: roleId
      };
      getRoleTypeMenuInfo(param).then((res) => {
        this.roleTypeMenu = res.data;
        // 1. 判断是否是首页 , 是首页则禁用
        this.roleTypeMenu.forEach((e) => {
          if (e.id == 1) {
            e.disabled = true;
          }
        });
        // 2. 获取选中权限
        res.data.forEach((e) => {
          e.children.forEach((m) => {
            if (m.isHave == 1) {
              this.roleTypeId.push(m.id);
              this.roleTypeIdP.push(m.parentId);
            };
          });
          if (e.children.find(t => t.isHave == 0)){
            return false;
          } else {
            this.roleTypeId.push(e.id);
          }
        });
        this.$nextTick(function () {
          this.$refs.tree.setCheckedKeys(this.roleTypeId);
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-tree {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 16px;
  /deep/& > .el-tree-node.is-expanded.is-focusable {
    width: 287px;
    min-height: 244px;
    margin-bottom: 48px;
    border-right: 1px solid #f1f2f5;
    box-sizing: border-box;
  }
  /deep/ .el-tree-node__content {
    width: 287px;
    box-sizing: border-box;
  }
  /deep/ .el-tree-node.is-current.is-focusable {
    width: 287px;
    border-right: 1px solid #f1f2f5;
    box-sizing: border-box;
  }
}
.titleTips {
  width: 100%;
  height: 64px;
  background: linear-gradient(90deg, #ebf0fa 0%, #ebf0fa 100%);
  border-radius: 8px 8px 0px 0px;
  display: flex;
  justify-content: left;
  align-items: center;
  padding-left: 24px;
  box-sizing: border-box;
  .titleTips-left {
    display: inline-block;
    width: auto;
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2d2f33;
    line-height: 28px;
    margin-right: 8px;
  }
  .titleTips-right {
    width: 68px;
    height: 22px;
    background: #d8ebff;
    border-radius: 2px;
    text-align: center;
    line-height: 22px;
    font-size: 13px;
    font-weight: 400;
    color: #006aff;
  }
}
.roleTypeBorder {
  width: 100%;
  height: auto;
  background: #fff;
  border-radius: 8px;
  padding: 32px;
  .title {
    width: 64px;
    height: 22px;
    font-size: 16px;
    font-weight: 500px;
    color: #45494d;
    line-height: 22px;
  }
}
</style>